export default require("./Completion").default
